import Link from 'src/components/Link'
import styled from '@emotion/styled'

type ProductHorizontalCardProps = {
  isBlackFriday?: boolean
}

export const ProductHorizontalCard = styled(Link)<ProductHorizontalCardProps>`
  display: flex;
  justify-content: center;
  width: auto;
  height: 100%;
  background-color: ${({ isBlackFriday }) => isBlackFriday && '#fff'};
  border-radius: ${({ isBlackFriday }) => isBlackFriday && '0.5rem'};

  > div {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    background-color: #fff;
    padding-left: 0;
    padding-right: 0;

    @media (max-width: 480px) {
      padding: 0.875rem;
    }

    @media (max-width: 320px) {
      > div {
        > div {
          > div {
            width: 100%;
          }
        }
      }
    }
  }
`
